import { navItems } from "@/mocks/homeContent";

export default function Footer() {
  return (
    <footer className="w-full bg-foreground-900 py-12">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-3">
          <div>
            <a href="#home" className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-600 text-background-50">
                <i className="ri-radio-fill text-lg"></i>
              </span>
              <span className="font-display text-xl font-bold text-background-50">曝光导航</span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-background-300">
              聚焦公开信息聚合与素材征集的信息导航平台，以规范、审慎、可追溯的方式承接每一条真实线索。
            </p>
            <div className="mt-5 flex items-center gap-2 text-xs text-background-400">
              <i className="ri-mail-line text-base"></i>
              contact@exposenav.example
            </div>
          </div>

          <div>
            <h3 className="font-display text-sm font-bold uppercase tracking-wide text-background-100">
              栏目导航
            </h3>
            <ul className="mt-4 grid grid-cols-2 gap-x-4 gap-y-2.5">
              {navItems.slice(1).map((item) => (
                <li key={item.key}>
                  <a
                    href={item.href}
                    className="inline-flex items-center gap-1.5 text-sm text-background-300 transition-colors hover:text-accent-300"
                  >
                    <i className="ri-arrow-right-s-line text-accent-500"></i>
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-display text-sm font-bold uppercase tracking-wide text-background-100">
              内容原则
            </h3>
            <ul className="mt-4 space-y-2.5 text-sm text-background-300">
              <li className="flex items-center gap-2">
                <i className="ri-check-line text-accent-400"></i> 事实优先 · 证据链完整
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-check-line text-accent-400"></i> 核验前置 · 及时更正
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-check-line text-accent-400"></i> 隐私审慎 · 合规底线
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-check-line text-accent-400"></i> 对等回应 · 授权清晰
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-start justify-between gap-3 border-t border-background-200/15 pt-6 text-xs text-background-400 sm:flex-row sm:items-center">
          <p>© 2026 曝光导航 · 保留所有权利</p>
          <p>本站为公开信息聚合与素材征集导航平台，请务必以事实与法规为准绳提交内容。</p>
        </div>
      </div>
    </footer>
  );
}